/**
 * Card wrapper component
 */

import type { ComponentPropsWithoutRef } from "react";

type CardProps = ComponentPropsWithoutRef<"div">;

export function Card({ className = "", children, ...rest }: CardProps) {
  return (
    <div
      className={`rounded-xl bg-surface-primary p-4 shadow-sm sm:p-6 ${className}`}
      {...rest}
    >
      {children}
    </div>
  );
}
